<script setup lang="ts">
withDefaults(
  defineProps<{
    tag?: string;
  }>(),
  {
    tag: 'section',
  }
);
</script>

<template>
  <component :is="tag" :class="$style.section">
    <slot />
  </component>
</template>

<style lang="scss" module>
.section {
  background-color: $color-surface-primary;
  border-radius: $border-radius-outer-radius;
  box-shadow: $shadow-4;
}
</style>
